/*
 * WO-35 — putting a record id into a web address.
 *
 * About a third of the tenders have "/" in their id (it comes from the portal's reference number,
 * e.g. "Qatar Monaqasat:555/2026"). A "/" in an address means "next level", and the server decodes
 * %2F back to "/" before choosing the route, so such a tender could not be opened, edited, deleted,
 * linked or added to the CRM. Every "/" is therefore written as "∕" (U+2215, DIVISION SLASH); the
 * server turns it back into "/" (backend/utils/path_ids.py). Ids without "/" come out exactly as
 * encodeURIComponent would give them.
 */
export const PATH_SLASH = '∕';

/** The id as one piece of a web address: pathId('Qatar Monaqasat:555/2026') → 'Qatar%20Monaqasat%3A555%E2%88%952026'. */
export const pathId = (id) => encodeURIComponent(String(id).replace(/\//g, PATH_SLASH));

/** The reverse, for an id read back from the browser's own address (react-router's :id). */
export const idFromPath = (value) => (value == null ? value : String(value).replace(/∕/g, '/'));
